// external-scripts.service.ts
import {inject, Injectable} from '@angular/core';
import {createLogger} from "../../shared/helpers/logger/logger";
import {RuntimeService} from "./runtime.service";

const logger = createLogger('ExternalScriptsService');

@Injectable({
    providedIn: 'root',
})
export class ExternalScriptsService {
    readonly #runtimeService = inject(RuntimeService);

    constructor() {
    }

    loadScript(src: string, id: string, async: boolean = false): void {
        if (this.#runtimeService.isBrowser && !document.getElementById(id)) {
            const script = document.createElement('script');
            script.id = id;
            script.src = src;
            script.async = async;
            document.head.appendChild(script);
        }
    }

    loadInlineScript(content: string, id: string): void {
        if (this.#runtimeService.isBrowser && !document.getElementById(id)) {
            const script = document.createElement('script');
            script.id = id;
            script.type = 'text/javascript';
            script.text = content;
            document.head.appendChild(script);
        }
    }

    // New method to load Google Maps API
    loadGoogleMapsApi(apiKey: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            if (this.#runtimeService.isBrowser && !document.getElementById('google-maps-api')) {
                const script = document.createElement('script');
                script.id = 'google-maps-api';
                script.type = 'text/javascript';
                script.text = `(g => {
          var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__",
              m = document, b = window;
          b = b[c] || (b[c] = {});
          var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams,
              u = () => h || (h = new Promise(async (f, n) => {
                  await (a = m.createElement("script"));
                  e.set("libraries", [...r] + "");
                  for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
                  e.set("callback", c + ".maps." + q);
                  a.src = \`https://maps.\${c}apis.com/maps/api/js?\` + e;
                  d[q] = f;
                  a.onerror = () => h = n(Error(p + " could not load."));
                  a.nonce = m.querySelector("script[nonce]")?.nonce || "";
                  m.head.append(a)
              }));
          d[l] ? logger.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n))
      })({
          v: "weekly",
          key: '${apiKey}'
      });`;

                script.onload = () => resolve();
                script.onerror = () => reject(new Error('Google Maps API failed to load.'));
                document.head.appendChild(script);
            } else {
                logger.warn('Google Maps API already loaded.');
                resolve();
            }
        });
    }
}
